import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isDark: false,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme(state, action) {
      state.isDark = action.payload.isDark;
    },
  },
});

export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;
